import type { TFunction } from 'i18next';
import { apiErrorCode, describeApiError } from '@/lib/describeApiError';
import { WORK_ORDER_SIGNATURE_REQUIRED_CODE } from '@/types';

export { WORK_ORDER_SIGNATURE_REQUIRED_CODE };

export const WORK_ORDER_APPROVAL_CARD_ELEMENT_ID = 'work-order-approval-card';
export const OPEN_APPROVAL_CARD_EVENT = 'os-buddy:open-approval-card';

export function isWorkOrderSignatureRequiredError(error: unknown): boolean {
  return apiErrorCode(error) === WORK_ORDER_SIGNATURE_REQUIRED_CODE;
}

/**
 * Maps 409 WORK_ORDER_SIGNATURE_REQUIRED from start / ready-to-invoice onto
 * a localized sentence. Call with a workorders-bound `t` and
 * `codePrefix: 'errorCode'`.
 */
export function describeWorkOrderSignatureRequiredError(
  error: unknown,
  t: TFunction,
  fallback: string,
): string {
  return describeApiError(error, t, { codePrefix: 'errorCode', fallback });
}

export function openWorkOrderApprovalCard(): void {
  const el = document.getElementById(WORK_ORDER_APPROVAL_CARD_ELEMENT_ID);
  el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  window.dispatchEvent(new Event(OPEN_APPROVAL_CARD_EVENT));
}
